
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.97 6.093a5.724 5.724 0 011.26-2.135c2.085-2.232 5.462-2.232 7.546 0l.57.614h-1.677c-.59 0-1.067.51-1.067 1.143 0 .632.477 1.143 1.067 1.143h4.264c.59 0 1.067-.511 1.067-1.143V1.144C16 .512 15.523 0 14.933 0s-1.067.51-1.067 1.143v1.828l-.583-.628c-2.917-3.125-7.645-3.125-10.562 0A8.053 8.053 0 00.96 5.336c-.198.597.096 1.247.65 1.457.553.211 1.163-.103 1.36-.696v-.004zM.768 9.19a1.05 1.05 0 00-.457.293 1.132 1.132 0 00-.297.635c-.01.06-.013.122-.013.182v4.557C0 15.49.477 16 1.067 16s1.067-.51 1.067-1.143v-1.825l.587.625c2.917 3.122 7.645 3.122 10.558 0a8.075 8.075 0 001.764-2.989c.197-.596-.097-1.246-.65-1.457-.553-.21-1.164.104-1.36.696a5.726 5.726 0 01-1.26 2.136c-2.084 2.232-5.462 2.232-7.545 0l-.004-.003-.57-.611h1.68c.59 0 1.067-.51 1.067-1.143 0-.632-.476-1.143-1.067-1.143H1.08c-.053 0-.106.004-.16.01a.74.74 0 00-.153.037z","fill":"#B4BCCF"}})])
          )
        }
      }
    